import React from 'react';
import PointSidebarMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/pointSidebar/PointSidebarMutateSingleVoyage";
import RouteSidebarMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/route/routeSidebar/RouteSidebarMutateSingleVoyage";
import RootSidebarLayoutSingleVoyage from "@containers/singleVoyage/views/layout/rootSidebar/RootSidebarLayoutSingleVoyage";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";


const SecondarySidebarMutateSingleVoyage = () => {

    const {
        modeSecondarySidebar,
        miniModeSecondarySidebar,
        setMiniModeSecondarySidebar,
    } = useViewContextMutateSingleVoyage()


    if (modeSecondarySidebar === 'hide') {
        return <></>
    }

    return (
        <RootSidebarLayoutSingleVoyage
            miniMode={miniModeSecondarySidebar}
            setMiniMode={setMiniModeSecondarySidebar}
        >
            {!miniModeSecondarySidebar && <>
                {modeSecondarySidebar === 'point' &&
                    <PointSidebarMutateSingleVoyage/>}

                {modeSecondarySidebar === 'route' &&
                    <RouteSidebarMutateSingleVoyage/>}
            </>}

        </RootSidebarLayoutSingleVoyage>
    );
};

export default SecondarySidebarMutateSingleVoyage;